import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fromEvent, Subscription } from 'rxjs';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-report-result',
  templateUrl: './report-result.component.html',
  styleUrls: ['./report-result.component.scss']
})
export class ReportResultComponent implements OnInit {
  @Output() eventPathEmitter = new EventEmitter()
  keySubscription!:Subscription
  constructor(
    private matDialogRef:MatDialogRef<ReportResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private globalService:GlobalService
  ) { }

  ngOnInit(): void {
    this.keySubscription = fromEvent<KeyboardEvent>(document, 'keydown')
    .subscribe(event => {
      if(event.key == 'Escape'){
        event.preventDefault()
        this.matDialogRef.close()
      }
      if(event.key == 'Enter'){
        event.preventDefault()
        this.emit(event)
      }
    });
    if(!this.data.buttons || (this.data.buttons && this.data.buttons.length==0)){
      this.data.buttons = []
      this.data.buttons.push({buttonText:'بستن', path:null})
    }
    
  }
  btnClick(){
    if(this.data.buttonText) this.globalService.scrollTop()
  }
  emit(item:any){
    this.eventPathEmitter.emit(item.path)
  }
  ngOnDestroy(): void {
    this.keySubscription.unsubscribe()
  }
}
